import lazyDirective from "../async";
import tooltip from "./v-tooltip.vue";

export default Vue => {
  Vue.directive(
    "tooltip",
    lazyDirective(() => import("v-tooltip").then(({ VTooltip }) => VTooltip))
  );
};
